import { Pipe, PipeTransform } from '@angular/core';
import { KeyFigureElement } from '@widgets';
import { HashMap } from '@datorama/akita';
import { Acct } from '../../../../shared/state/accts/acct.model';
import { AccountIssuer } from '../../../../pages/admin/state/account-issuers/account-issuer.model';

@Pipe({
    name: 'sbSubAccounts',
    standalone: true
})
export class SbSubAccountsPipe implements PipeTransform {
    transform(
        elements: Array<KeyFigureElement>,
        accounts: HashMap<Acct>,
        issuers: HashMap<AccountIssuer>
    ) {
        return elements.map((element) => {
            const account = accounts[element['value'].rawValue.accountId];
            const issuer = issuers[account.accountIssuerId];
            return {
                id: account.accountId,
                name:
                    account?.accountDisplayName ||
                    account?.accountClientAlias ||
                    account?.accountIssuerShortName,
                issuer,
                accountNumber: account?.accountNumber,
                balance: element['value'].rawValue.marketValue,
                relativeDailyPerformance:
                    element['value'].rawValue.relativeDailyPerformance,
                currency: element['value'].rawValue.currency
            };
        });
    }
}
